import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

export const Spaces = {
  read: (query, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${query}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      null,
    );
  },

  readV2: (query, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v2/spaces-v2/spaces/${query}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      null,
    );
  },

  create: (accessToken, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: "/v1/spaces",
      method: "POST",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      payload,
    );
  },

  update: (query, accessToken, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${query}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      payload,
    );
  },
  getFaq: (spaceId, faqType, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${spaceId}/faqs/${faqType}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      null,
    );
  },
  updateFaq: (spaceId, faqType, accessToken, payload, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/spaces/${spaceId}/faqs/${faqType}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      payload,
    );
  },
};
